import React, { Fragment, useEffect, useState } from 'react'
import { IFile, IReport, IReportData, IRequestedChange } from '../../helpers/Interfaces';
import { getTimeDifference, validDateField } from '../../helpers/HelperFunctions';
import Loading from '../Loading/Loading';
import SendRequest from '../../assets/images/SendRequest.svg'
import FileUploadUI from '../FileUploadUI/FileUploadUI';
import { getDocumentMedia } from '../../helpers/FirebaseFunctions';

type ReportUploadedViewProps = {
    readonly selectedDocument: IReport,
    readonly loading: boolean,
    readonly setShowAlert: CallableFunction,
    readonly setLoading: CallableFunction,
    readonly setAddedFiles: CallableFunction,
    readonly showAlert: any,
    readonly addedFiles: IFile[],
    readonly requestedChanges: IRequestedChange[],
    readonly requestChanges: CallableFunction,
    readonly report: IReportData
}

function ReportUploadedView(props: ReportUploadedViewProps) {
    const [requestChange, setRequestChange] = useState("");
    const [media, setMedia] = useState([] as IFile[]);
    const [removedMedia, setRemovedMedia] = useState([] as IFile[]);

    useEffect(() => {
        getMedia(props.selectedDocument.mediaId)
    }, [props.selectedDocument.mediaId])

    async function getMedia(mediaId: string) {
        props.setLoading(true);
        await getDocumentMedia(mediaId, setMedia)
        props.setLoading(false);
    }

    function requestChanges() {
        props.setLoading(true);

        if (requestChange === "") {
            let newShowAlert = props.showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Comment is Required";
            newShowAlert.open = true;
            props.setShowAlert((prevDetails: any) => ({ ...prevDetails, ...newShowAlert }));
            props.setLoading(false);
            return;
        }

        let data = {
            documentId: props.selectedDocument.id,
            requestedChange: requestChange
        }

        props.requestChanges(data, media, removedMedia);
    }

    async function removeFile(file: IFile) {
        props.setLoading(true);
        let _removedMedia = removedMedia;
        _removedMedia.push(file);
        setRemovedMedia(_removedMedia);

        let _media = media;
        let _filteredArray = _media.filter((_file) => _file !== file);
        setMedia(_filteredArray);
        props.setLoading(false);
    }

    function handleAddMedia(newFile: IFile) {
        setMedia((prev: IFile[]) => [...prev, newFile]);
    }

    return (
        <div className="view-document-body report-template-content">
            <div className="report-uploaded-view">
                {/* <div className="report-content">
                    {!props.loading
                        ? (<div className="report-pdf-view">
                            {props.report?.pdf?.link
                                ? (
                                    <iframe className='pdf-style' height={'100%'} width={'100%'} src={`${props.report?.pdf?.link}#toolbar=0`}
                                        title="Embedded PDF" />
                                )
                                : (<></>)}
                        </div>)
                        : (<div className="loading-content">
                            <Loading color="black" />
                        </div>)}
                </div> */}
                <div className="requested-changes">
                    <div className="requested-changes-title">
                        Requested Changes
                    </div>
                    <div className="requested-changes-view">
                        {props.requestedChanges?.map((change, index) => (
                            <div className="requested-changes-card-outline" key={index}>
                                <div className="requested-changes-card">
                                    <div className="changes-requested-header">
                                        <div className="user-name">{change.changeRequestedBy}</div>
                                        {!change.completedDate
                                            ? (<span>Pending</span>)
                                            : (<></>)
                                        }
                                    </div>
                                    {change.completedDate
                                        ? (<div className="changes-completed-header">
                                            Completed<span>{validDateField(change?.completedDate)}</span>
                                        </div>)
                                        : (<></>)
                                    }
                                    <div className="changes-note">
                                        {change.requestedChange}
                                    </div>
                                    <div className="duration">{getTimeDifference(change.createdDate)}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="add-request">
                        <div className="add-request-comment">
                            <textarea value={requestChange} onChange={(data) => setRequestChange(data.target.value)} rows={3}
                                placeholder="Enter Comment" />
                        </div>
                        {props.loading
                            ? (<Loading color='orange' />)
                            : (<img onClick={requestChanges} src={SendRequest} alt="SendRequest" />)
                        }
                    </div>
                </div>
            </div>
            <div className="report-uploaded-files-view">
                <FileUploadUI setLoading={props.setLoading} setMedia={handleAddMedia} media={media}
                    setShowAlert={props.setShowAlert} removeFile={removeFile} removeMulitpleFiles={() => { }} />
            </div>
        </div>
    )
}

export default ReportUploadedView